/**
 * Created by pablo on 8/22/17.
 */

var invoice_book_service;
(function ($, undefined) {
    'use strict';

    invoice_book_service = {
        checkInvoiceBook: function(e,states){
            $('#ok-icon').hide();
            $('#alert-icon').hide();
            $('#invoice_book_msg_label').hide();
            $('#invoice_book_error_label').hide();
            if($('#invoice_book_prefix').val()!= ""){
                $.ajax({
                    url: "/invoice_book/checkInvoiceBookFe/"+$('#invoice_book_prefix').val()+"/"+integrationId,
                    success: function(result){
                        var response = JSON.parse(result);
                        $('#invoice_book_msg_label').show();
                        if(response.success){
                            $('#invoice_book_msg_label').text(response.message);
                            $('#ok-icon').show();
                        }
                        states.isValidInvoiceBook = true;
                    },
                    error:function(result){
                        $('#alert-icon').show();
                        $('#invoice_book_error_label').text(result.responseJSON.message);
                        $('#invoice_book_error_label').show();
                        states.isValidInvoiceBook = false;
                    }
                });
            }
        }
    };
    //binding
})(jQuery);



var configuration;
var form = "configuration_form";
(function ($, undefined) {
    'use strict';
    configuration = {};
    configuration.states = {};

    configuration.validateInvoiceBook = function(e){
        e.preventDefault();
        invoice_book_service.checkInvoiceBook(e,configuration.states);
    };

    configuration.sku_shipping_enable = function(e){
        $("#shipping_item_code").prop('disabled',!$('#add_sku_to_shipping').is(':checked'));
    };

    configuration.inventory_sync_enabled = function(e){
        var inventory_sync_enabled = !$("#inventory_sync").is(':checked');
        $("#use_item_vat").prop('disabled',inventory_sync_enabled);
        $("#account_from_item").prop('disabled',inventory_sync_enabled);
        $("#use_inventory_description_on_invoice").prop('disabled',inventory_sync_enabled);

    };

    configuration.cost_centre_enable = function(e){
        var ccEnabled = !$("#cost_centre_enabled").is(':checked');
        $("#cost_centre_1").prop('disabled',ccEnabled);
        $("#cost_centre_2").prop('disabled',ccEnabled);
    };

    configuration.marketplace_enable = function(e){
        var ccEnabled = !$("#is_market_place").is(':checked');
        $("#marketplace_id").prop('disabled',ccEnabled);
        $("#marketplace_account_id").prop('disabled',ccEnabled);
    };

    configuration.delivery_note_enable = function(e){
        var delivery_note_enabled = !$("#delivery_note").is(':checked');
        $("#delivery_note_book_id").prop('disabled',delivery_note_enabled);
    };

    configuration.deposit_enable = function(e){
        var deposit_enabled = !$("#multideposit_check").is(':checked');
        $("#deposit_id").prop('disabled',deposit_enabled);
    };

    configuration.me_full_deposit_enable = function(e){
        var me_full_deposit_enable = !$("#me_full_deposit_check").is(':checked');
        $("#me_full_deposit_id").prop('disabled',me_full_deposit_enable);
    };

    configuration.add_sku_to_shipping_enable = function(e){
        var add_sku_to_shipping_enabled = !$("#add_sku_to_shipping").is(':checked');
        $("#shipping_item_code").prop('disabled',add_sku_to_shipping_enabled);
    };

    configuration.draft_invoice_enabled = function(e){
        var draft_invoice_enabled = $("#draft_invoice").is(':checked');
        if(draft_invoice_enabled){
            $("#invoice_delay").val("");
        }
        $("#invoice_delay").prop('disabled',draft_invoice_enabled);
    };

    configuration.submitForm = function(e){
        e.preventDefault();
        var isValid = true;
        if(!configuration.states.isValidInvoiceBook ){
            isValid = false;
        }
        if(isValid){
        }
        configuration.form.submit();
    };

    $("#invoice_book_prefix").blur(configuration.validateInvoiceBook);

    //binding
    $("#submit_config").on('click',configuration.submitForm);
    $("#add_sku_to_shipping").on('click',function () {
        configuration.sku_shipping_enable();
    });

    $("#inventory_sync").on('click',function () {
        configuration.inventory_sync_enabled();
    });


    $("#delivery_note").on('click',function () {
        configuration.delivery_note_enable();
    });

    $("#cost_centre_enabled").on('click',function () {
        configuration.cost_centre_enable();
    });

    $("#is_market_place").on('click',function () {
        configuration.marketplace_enable();
    });
    

    $("#multideposit_check").on('click',function () {
        configuration.deposit_enable();
    });

    $("#me_full_deposit_check").on('click',function () {
        configuration.me_full_deposit_enable();
    });

    // $("#invoice_shipping_without_vat").on('click',function () {
    //     configuration.invoice_shipping_enable();
    // });

    $("#draft_invoice").on('click',function () {
        configuration.draft_invoice_enabled();
    });

    configuration.form = $("#"+form);

    configuration.sku_shipping_enable();
    configuration.cost_centre_enable();
    configuration.delivery_note_enable();
    configuration.deposit_enable();
    configuration.me_full_deposit_enable();
    configuration.add_sku_to_shipping_enable();
    configuration.inventory_sync_enabled();
    configuration.draft_invoice_enabled();
    configuration.marketplace_enable();
})(jQuery);


require('./services/invoice_book');



// WEBPACK FOOTER //
// ./resources/assets/js/configurations.js